module.exports = __webpack_public_path__ + "img/birthday-2004.32c59726.jpg";